import { Boundaries } from "@planzone/core";
import { Identifiable, Event } from "@planzone/dto";

function handleAssignTagRequest(
  event: Identifiable<Event>,
  { assignableId, tag }: Boundaries["assignTag"]["request"],
): Identifiable<Event> {
  return event.uuid === assignableId
    ? {
        ...event,
        tags: event.tags ? [...event.tags, tag] : [tag],
      }
    : event;
}

function handleAssignTagSuccess(
  event: Identifiable<Event>,
  { assignableId, tag }: Boundaries["assignTag"]["success"],
): Identifiable<Event> {
  if (event.uuid !== assignableId) return event;

  const tagExists = event.tags?.some(({ name }) => name === tag.name);

  return tagExists
    ? event
    : {
        ...event,
        tags: event.tags ? [...event.tags, tag] : [tag],
      };
}

function handleAssignTagFailure(
  event: Identifiable<Event>,
  { assignableId, tag }: Boundaries["assignTag"]["failure"],
): Identifiable<Event> {
  return event.uuid === assignableId
    ? {
        ...event,
        tags: event.tags.filter(({ name }) => name !== tag.name),
      }
    : event;
}

export {
  handleAssignTagRequest,
  handleAssignTagSuccess,
  handleAssignTagFailure,
};
